import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { BackendService } from "../backend.service";
import { UserService } from "../../user/user.service";

@Injectable()
export class AdminService {
  constructor(
    private db: AngularFireDatabase,
    private userService: UserService
  ) { }

  async create(user): Promise<any> {
    user.isAdmin = true;
    const userExists = await this.doesUserExistAsAnAdmin(user.id);
    if (userExists) {
      return {
        state: false,
        message: "User already exists as an Admin. Verify user\"s email"
      };
    } else {
      Promise.all([
        this.db.list(`/admin`).set(user.id, true),
        this.db.list(`/profile`).update(user.id, user)
      ]).then();

      return { state: true, message: "Admin successfully added." };
    }
  }

  private async doesUserExistAsAnAdmin(userId): Promise<any> {
    return new Promise<any>(resolve => {
      this.db
        .object(`/admin/${userId}`)
        .valueChanges()
        .subscribe(data => resolve(data));
    });
  }

  list(): any {
    return this.db
      .object("/admin")
      .valueChanges()
      .map(data => {
        const adminIds = Object.keys(data);

        return adminIds.map(id => {
          const $adminProfile = this.db.object(`/profile/${id}`).valueChanges();

          return Observable.zip($adminProfile, profile => {
            if (profile) {
              profile["name"] =
                profile["firstName"] + " " + profile["lastName"];

              return profile;
            }
          });
        });
      })
      .flatMap(user => {
        return Observable.combineLatest(user);
      });
  }

  update(user): any {
    user.updatedAt = BackendService.getCurrentTimeStamp();
    this.db.list(`/profile`).update(user.id, user);

    return { state: true, message: "Admin successfully updated." };
  }

  delete(userId): any {
    this.db.list(`/admin/${userId}`).remove();
    this.db.list(`/profile/${userId}`).remove();
  }

  deactivate(userId): any {
    const updateTime: any = BackendService.getCurrentTimeStamp();
    this.db.list(`/profile`).update(userId, {
      isAdmin: false,
      wasAdmin: true,
      updatedAt: updateTime
    });
  }

  activate(userId): any {
    const updateTime: any = BackendService.getCurrentTimeStamp();
    this.db.list(`/profile`).update(userId, {
      isAdmin: true,
      wasAdmin: null,
      updatedAt: updateTime
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/user/admin.service.ts